import { Exclude, Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-option-code-raw-dto';
import { GLSubcategorySelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/gl-account/glsubcategory-selector-result-dto';

export class WFEPaymentRequestWorkflowItemRawDto {
    description: string;
    itemAmount: number;
    glAccountNumber: string;
    subCategoryId: number;
    dimensions: string;
    crudAction: string;
    templateId: number;
    apBillItemId: number;
    targetCommunityId: number;
    crossAPBillId: number;
    crossAPBillItemId: number;

    @Exclude()
    itemId: number;

    @Exclude()
    @Type(() => DimensionOptionCodeRawDto)
    dimensionList: Array<DimensionOptionCodeRawDto>;

    @Exclude()
    @Type(() => GLSubcategorySelectorResultDto)
    subCategorySource: Array<GLSubcategorySelectorResultDto>;
}
